<template>
  <div class="page-wrapper">
    <header class="header">
      <div class="control-btn" @click="handleBackBtn">
        <BaseIcon iconName="chevronLeft"></BaseIcon>
      </div>

      <div class="header-content">
        <h1 class="header-1">
          <img src="@/assets/logotext.png" :alt="$t('app.logoAlt')" class="logo" />
        </h1>
      </div>
      <LanguageSwitcher class="language-control" />
    </header>

    <div class="page-content">
      <router-view></router-view>
    </div>

    <footer>
      <p class="caption">{{ $t('layout.termsAndPrivacy') }}</p>
    </footer>
    <CookieConsent />
  </div>
</template>

<script setup>
import BaseIcon from "@/components/BaseComponents/BaseIcon.vue";
import { useRouter } from "vue-router";
import CookieConsent from "@/components/CookieConsent.vue";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
const router = useRouter();

function handleBackBtn() {
  router.push("app");
}
</script>

<style scoped>
.page-wrapper {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 2vw;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 10vh;
  position: relative;
}

.header-content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-sm-md);
}

.logo {
  height: 70px;
  width: auto;
  padding: 0 var(--spacing-sm-lg);
}

.control-btn {
  flex-shrink: 0;
}

.language-control {
  margin-left: auto;
}

.page-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 650px;
  flex: 1;
}

footer {
  text-align: center;
  margin-top: var(--spacing-xl);
}

.caption {
  color: var(--color-white-40);
}

@media (max-width: 970px) {
  .page-content {
    min-height: auto;
  }
}
</style>
